<button
    mat-icon-button
    class="st-templates-secondary-cta-button-copy"
    [matTooltip]="languageSettings()?.PSTWebCopyViewToClipboard"
    (click)="copyToClipboard()">
    <mat-icon class="material-symbols-outlined">file_copy</mat-icon>
</button>
